import React from "react";
import PropTypes from "prop-types";
import { Row, Table, Container } from "react-bootstrap";
import DataTablePagination from "./DataTablePagination";
import TableModifiers from "./TableModifiers";
import ExportButton from "./ExportButton";
import "./DataGrid.css";

export default class DataGridNew extends React.Component {

  render() {
    let columnHeaders = this.props.isAdmin ? this.props.adminHeaders.concat(this.props.headers) : this.props.headers;
    let firstIndexDisplayed = this.state.displayedScreen * this.state.numberPerScreen;
    let lastIndexDisplayed = firstIndexDisplayed + this.state.numberPerScreen;
    
    const csvHeaders = columnHeaders.flatMap(
      h => h.columns.map(col => ({ label: col.label, key: col.key }))
    );

    const handleDataStyle = (header, column) => {
      let cls = '';
      if (header.key === 'hours') {
        cls += 'hours-data';
      } else if(header.key === 'dollars') {
        cls += 'dollars-data'
      }

      if (column.isNumber) {
        cls += ' number-data';
      }

      return cls;
    };

    const handleValueFormat = (column, data) => {
      let value = data;

      if(column.isNumber) {
        value = value.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
      }

      return value;
    };
    
    const exportButton = (
      <ExportButton
        data={this.props.data}
        headers={csvHeaders || []}
        page={this.props.exportName || "revShareAppExport"}
        pageModifier={this.props.isAdmin ? "admin" : ""}
      />
    );

    return (
      <Container className="data-grid report-grid" fluid>
        <TableModifiers
          columns={this.props.tableModifiers ? [exportButton, ...this.props.tableModifiers] : [exportButton]}
        />
        <DataTablePagination
          displayedScreen={this.state.displayedScreen}
          numberOfScreens={this.numberOfScreens()}
          numberPerScreen={this.state.numberPerScreen}
          numberPerScreenOptions={this.numberPerScreenOptions}
          setDisplayedScreen={this.setDisplayedScreen}
          setNumberPerScreen={this.setNumberPerScreen}
        />
        <Row>
          <Table hover responsive>
                    <thead>
                        <tr>
                            {columnHeaders.map((header) => (
                                <th
                                  key={header.key}
                                  colSpan={header.columns.length}
                                  className='default-col-group'
                                  style={header.headerStyle || {}}>{header.label}
                                  </th>
                            ))}
                        </tr>
              <tr>
                {columnHeaders.map((header) => (
                  header.columns.map(col => (
                    <th
                    key={col.key}
                    className={handleDataStyle(header, col)}
                    style={col.headerStyle || {}}>{col.label}</th>
                  ))
                ))}
                {this.props.actionButtons ? <th style={{ textAlign: "center" }}>Actions</th> : null}
              </tr>
            </thead>
            <tbody>
              {this.props.data.slice(firstIndexDisplayed, lastIndexDisplayed).map((row, index) => (
                <tr key={"tableRow" + index}>
                      {columnHeaders.map((header) => (
                          header.columns.map(col => (
                            <td
                            key={col.key + index}
                            className={handleDataStyle(header, col)}
                            style={col.style || {}}>{handleValueFormat(col, row[col.key])}</td>
                              ))

                  ))}
                  {this.props.actionButtons ? (
                    <td key={"row" + index + "_actions"} style={{ textAlign: "center" }}>{this.props.actionButtons(row)}</td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </Table>
        </Row>
      </Container>
    );
  }

  constructor(props) {
    super(props);
    this.state = {
      numberPerScreen: this.numberPerScreenOptions[2].num,
      displayedScreen: 0,
    };

    this.numberOfScreens = this.numberOfScreens.bind(this);
    this.setDisplayedScreen = this.setDisplayedScreen.bind(this);
    this.setNumberPerScreen = this.setNumberPerScreen.bind(this);
  }

  numberOfScreens() {
    return Math.ceil(this.props.data.length / this.state.numberPerScreen);
  }

  setDisplayedScreen(screenNumber) {
    this.setState({
      displayedScreen: screenNumber,
    });
  }

  setNumberPerScreen(perScreen) {
    let numberPerScreen = perScreen === -1 ? this.props.data.length : perScreen;
    this.setState({
      numberPerScreen: numberPerScreen,
    });
    let numberOfScreens = Math.ceil(this.props.data.length / numberPerScreen);
    if (this.state.displayedScreen > numberOfScreens) {
      this.setDisplayedScreen(numberOfScreens - 1);
    }
  }

  maxDisplayedScreenOptions = 10;

  numberPerScreenOptions = [
    { num: 10, display: "10" },
    { num: 20, display: "20" },
    { num: 50, display: "50" },
    { num: -1, display: "All" },
  ];
}

DataGridNew.propTypes = {
  actionButtons: PropTypes.func,
  adminHeaders: PropTypes.array,
  data: PropTypes.array.isRequired,
  exportName: PropTypes.string,
  isAdmin: PropTypes.bool,
  isGhosting: PropTypes.bool,
  headers: PropTypes.array.isRequired,
  tableModifiers: PropTypes.array,
};
